import { render, staticRenderFns } from "./referral_program_types.vue?vue&type=template&id=12c23654&scoped=true&"
import script from "./referral_program_types.vue?vue&type=script&lang=js&"
export * from "./referral_program_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c23654",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12c23654')) {
      api.createRecord('12c23654', component.options)
    } else {
      api.reload('12c23654', component.options)
    }
    module.hot.accept("./referral_program_types.vue?vue&type=template&id=12c23654&scoped=true&", function () {
      api.rerender('12c23654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/referral_program_types.vue"
export default component.exports